import getFormatMessage from '../locales/get-format-message';

export const CompanyRejectTypeLabelMap = {
  creditCode: getFormatMessage('company_credit_code'),
  businessLicenseImageUrl: getFormatMessage('company_license'),
  name: getFormatMessage('company_name'),
  description: getFormatMessage('company_desc'),
  contactName: getFormatMessage('company_contact_name'),
  contactPhone: getFormatMessage('company_contact_phone'),
  contactIDCode: getFormatMessage('company_contact_id'),
  projectName: getFormatMessage('studio_auth_project_name'),
  projectOwner: getFormatMessage('studio_auth_project_owner'),
  productCode: getFormatMessage('KPI Code'),
};

export const InternalCertRejectTypeLabelMap = {
  projectName: getFormatMessage('studio_auth_project_name'),
  projectOwner: getFormatMessage('studio_auth_project_owner'),
  productCode: 'KPI Code',
};
